// extracted by mini-css-extract-plugin
export var mediaBlock = "MediaContact-module--media-block--2cG6A";
export var mediaBlockListView = "MediaContact-module--media-block-list-view--28F_s";
export var noBottomBorder = "MediaContact-module--no-bottom-border--1ptkI";
export var mediaBlockDetailView = "MediaContact-module--media-block-detail-view--2nX-Y";
export var mediaNewsletter = "MediaContact-module--media-newsletter--K9rwV";
export var mediaHeading = "MediaContact-module--media-heading--3A83Z";
export var mediaContacts = "MediaContact-module--media-contacts--a5YRO";
export var mediaContactsElement = "MediaContact-module--media-contacts-element--2kCUo";
export var darkBg = "MediaContact-module--dark-bg--1avD2";